module.exports = __webpack_public_path__ + "static/media/微松冷链授权资质.0728449c.jpg";